/**
 * Starting point of the online check-in
 */
var MapSelectorView = require('./start-wait-list/map-selector');
var AccessibleLinkView = require('./stores-list/accessible-link');
var OptionsSelectorView = require('./start-wait-list/options-selector');

var requestsManager = require('../../shared/app-mobile/managers/requests-manager');

var StartWaitListModel = Backbone.Model.extend({
  defaults: {
    location: '',
    center: ''
  }
});

var AccessibleLinkModel = Backbone.Model.extend({
  defaults: {
    selectedStoreId: ''
  }
});

var StartWaitListView = Backbone.View.extend({

  template: 'start-wait-list.layout',

  initialize: function() {
    this.hasRendered = false;

    this.model = new StartWaitListModel;

    this.optionsSelectorView = new OptionsSelectorView({model: this.model});
    this.mapSelectorView = new MapSelectorView();
    this.accessibleLinkView = new AccessibleLinkView({
      model: new AccessibleLinkModel()
    });
  },

  refresh: function() {
    this.mapSelectorView.model.set('alreadyInQueue', false);
    this.mapSelectorView.clientInfoComponent.render();
  },

  /**
   *  Will be called when this page is loaded. The param basically contains the query string content.
   *  Depending on if newData contains a store ID, it will either show the map with or without a slected store.
   *  @param {string} newData.store contains a store ID or a store short name
   */
  setData: function (newData) {
    if (bookedby.app.getCurrentClient().get('loggedIn')) {
      this.checkUserIsInQueue();
    }

    bookedby.app.ignoreNextBooking = false;

    var deferred = $.Deferred();

    this.accessibleLinkView.model.set('selectedStoreId', newData.store || "");
    this.accessibleLinkView.render();

    if (newData.store) {
      // ignoreUserPosition = true because a store is already selected
      this.mapSelectorView.ignoreUserPosition = true;
      if (this.mapSelectorView.hasRendered) {
        this.mapSelectorView.selectStoreById(newData.store).then(deferred.resolve);
      } else {
        this.mapSelectorView.listenToOnce(this.mapSelectorView, 'user:positioned', _.bind(function(){
          this.mapSelectorView.selectStoreById(newData.store);
        },this));
        deferred.resolve();
      }
    } else {
      // ignoreUserPosition = false because no store is selected and will try to center on user location if allowed
      this.mapSelectorView.ignoreUserPosition = false;
      this.mapSelectorView.model.set('showStoreModal', false);
      if (newData.loc && newData.center) {
        this.model.set('location', newData.loc);
        this.model.set('center', newData.center);

        var center = _.map(this.model.get('center').split(';'), parseFloat);

        this.mapSelectorView.DEFAULT_LOCATION = {lat: center[1], lng: center[0]};
      }
      deferred.resolve();
    }
    return deferred;
  },

  /**
   * Uses the bookedby.routes.BOOKING.WAIT_LIST_CHECK APi endpoint to check if the logged user is already in some client queue.
   * If it is, the alreadyInQueue property is set and the "check-in" button is disabled in the store modal view.
   */
  checkUserIsInQueue: function() {
    var KEY = 'waitListCheck';
    var ajaxParams = {
      url: bookedby.routes.BOOKING.WAIT_LIST_CHECK,
      contentType: 'application/json',
      data: JSON.stringify({
        storeGroupUuid: window.bookedby.staticData.storeGroupId
      }),
      method: 'POST',
      cache: false,
    };

    var success = _.bind(function(data) {
      if (data.success && data.alreadyInQueue) {
        bookedby.app.getCurrentClient().set('alreadyInQueue', true);
        bookedby.app.getCurrentClient().set('alreadyInQueueStore', data.store.name);
        this.mapSelectorView.model.set('alreadyInQueue', true);
      } else {
        bookedby.app.getCurrentClient().set('alreadyInQueue', false);
        bookedby.app.getCurrentClient().set('alreadyInQueueStore', null);
        this.mapSelectorView.model.set('alreadyInQueue', false);
      }

      this.mapSelectorView.clientInfoComponent.render();
    }, this);

    requestsManager.newRequest(KEY, ajaxParams, true)
      .then(success);
  },

  /**
   * Invoked on location input change (when a location is selected from the dropdown list)
   */
  updateLocation: function() {
    if (_.isEmpty(this.model.get('location'))) {
      this.model.set('center', '');
      this.mapSelectorView.unsetCoordinatesAndUserPosition();

      return;
    }

    this.model.set('center', $("#geometryIdInput").val());

    if (_.isEmpty(this.model.get('center'))) {
      return;
    }

    var center = _.map(this.model.get('center').split(';'), parseFloat);

    global.bookedby.helpers.locationChosenEvent(this.model.get('location'));

    this.mapSelectorView.recomputeZoomAfterChangeLocation = true;
    this.mapSelectorView.setCoordinatesAndUserPosition(center[1], center[0])
    var marker = $("img.leaflet-marker-icon");
    marker.attr("alt", this.model.get('location'));
    marker.attr("title", "");
    marker.wrap("<div role='link' tabindex='0'></div>");

    $("img.leaflet-marker-shadow").attr("alt", "");
  },

  initEventListeners: function() {
    this.model.on('change:location', this.updateLocation, this);
  },

  removeEventListeners: function() {
    this.model.off('change:location', this.updateLocation, this);
  },

  beforeRender: function() {

    this.setView('#optionsSelector', this.optionsSelectorView);
    this.setView('#mapContainer', this.mapSelectorView);
    this.insertView('.js-view__accessible-link', this.accessibleLinkView);

    this.initEventListeners();

    if (this.hasRendered) {
      return false;
    }
    this.hasRendered = true;
    return true;
  },

  afterRender: function() {
    if (!this.isLoading) {
      bookedby.app.finishLoading();
    }
      setTimeout(function(){
          if(document.getElementById("map").hasAttribute("tabindex")){
              document.getElementById("map").removeAttribute("tabindex");
          }
      },0);
    var marker = $("img.leaflet-marker-icon");
    marker.attr("alt", this.model.get('location'));
    marker.attr("title", "");
    marker.wrap("<div role='link' tabindex='0'></div>");
  },

  cleanup: function() {
    this.model.set('location', '');

    this.removeEventListeners();
  },

});

module.exports = StartWaitListView;
